import { Div } from '@components/StyledTags'
import styled from 'styled-components'

export const ToggleContainer = styled(Div)`
  a {
    color: white;
    text-decoration: none;
  }
`
